"use client";

import { ClipboardCopy } from "lucide-react";
import { useEffect, useState } from "react";

import { ErrorDetails } from "@/apps/charm/lib/pages/core/ErrorDetails";
import { formatErrorText } from "@/apps/charm/lib/pages/core/format-error-text";
import { Button } from "@/ui/shadcn/component/button";
import { Card, CardContent, CardHeader } from "@/ui/shadcn/component/card";

interface Props {
  error: Error & { digest?: string };
  reset: () => void;
}

export default function GlobalErrorPage(props: Props) {
  const { error, reset } = props;
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    console.error(error);
  }, [error]);

  async function handleCopy() {
    try {
      await navigator.clipboard.writeText(formatErrorText(error));
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      // Clipboard API may not be available
    }
  }

  return (
    <html lang="en">
      <body>
        <div className="min-h-screen bg-background">
          <header className="flex items-center gap-2 border-b px-4 py-3">
            <span className="text-sm font-semibold">Charm</span>
          </header>
          <main className="py-32 flex items-center justify-center">
            <Card className="w-lg">
              <CardHeader className="font-bold text-destructive text-xl">
                Something went wrong
              </CardHeader>
              <CardContent className="space-y-6">
                <ErrorDetails error={error} />
                <div className="flex gap-2">
                  <Button onClick={() => reset()}>Try again</Button>
                  <Button variant="outline" onClick={handleCopy}>
                    <ClipboardCopy className="mr-2 size-4" />
                    {copied ? "Copied!" : "Copy error details"}
                  </Button>
                </div>
              </CardContent>
            </Card>
          </main>
        </div>
      </body>
    </html>
  );
}
